export enum CustomerFlowSlug {
  NEED_HELP = 'need_help',
  POSITIVE = 'positive',
  DECLARE_INTEREST = 'declare_interest',
  CANCEL_JOB = 'cancel_job',
  SOLVE_ISSUES = 'solve_issues'
}

export enum CCFModalType {
  JOB = 'job',
  BID = 'bid'
}
